module.exports = __webpack_public_path__ + "img/information.34764622.svg";